import { useAuth } from '@contexts/auth';
import { useSidebar } from '@contexts/sidebar';
import { Permissions } from '@utility/constants/permission';
import { useMemo } from 'react';

const fallbackPermission = Permissions.user;

export const isActionDisabled = permission =>
  [Permissions.upgrade, Permissions.user, Permissions.hidden].includes(
    permission ?? fallbackPermission,
  );

export const checkStarterPermission = (permission, isTrailStarterPlan) =>
  !(permission === Permissions.upgrade && isTrailStarterPlan);

export const isActionHidden = permission =>
  Permissions.hidden === (permission ?? fallbackPermission);

export function useUrlPermission(url = '', options = {}) {
  // @ts-expect-error - TS2339: Property 'matchParam' does not exist on type '{}'.
  const { matchParam = false, fullMatch = true } = options;
  // @ts-expect-error - TS2339: Property 'currentMenuPermission' does not exist on type 'unknown'.
  const { currentMenuPermission, getMenuByUrl } = useSidebar();
  const { subscription, isStarterPlan, isSuperAdmin } = useAuth();
  const { pathname, search = '' } = window?.location ?? {};

  const param = matchParam ? search : '';

  const permission = useMemo(
    () =>
      getMenuByUrl(pathname + param, { fullMatch, matchParam })?.permission ??
      getMenuByUrl(url + param, { fullMatch, matchParam })?.permission ??
      currentMenuPermission ??
      fallbackPermission,
    [url],
  );

  return {
    disabled:
      checkStarterPermission(
        permission,
        isStarterPlan && subscription?.trial,
      ) &&
      isActionDisabled(permission) &&
      !isSuperAdmin,
    hidden: isActionHidden(permission),
  };
}

export default useUrlPermission;
